module.exports = __webpack_public_path__ + "static/media/tag.c779a655.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/badges/tag.svg
 ** module id = 424
 ** module chunks = 0
 **/